export default "__VITE_ASSET__0ddd9a77__"